let UTILS = require("../libs/utils.js");
var v7754;
var v7755;
module.exports = {
  id: "blitz",
  name: "Blitz",
  alias: "blitz",
  endStats: ["sid", "name", "score", "kills", "deaths", "caps"],
  onKill: function (p9232, p9233, p9234) {
    p9232.dropFlag(p9234.flag);
  },
  rush: true,
  flags: true,
  teams: true,
  noScoreC: true
};